<template>
  <div class="d-flex align-center">
    <span
      class="mr-2 font-weight-bold"
      style="color: rgb(242, 201, 76); font-size: 14px; transform: translateY(1.5px);"
      >{{ count }}</span
    >
    <v-rating
      dense
      empty-icon="fas fa-star"
      full-icon="fas fa-star"
      half-icon="fas fa-star-half"
      background-color="#C4C4C4"
      class="d-flex"
      color="#F2C94C"
      length="5"
      size="10"
      :ripple="false"
      half-increments
      :value="roundNumber(count, 0.5, 'ceil')"
      :readonly="readonly"
    ></v-rating>
  </div>
</template>
<script>
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
};
</script>
